import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsDiameterSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.871 4.836 2.483-2.482-.707-.708-2.483 2.483a5 5 0 0 0-7.036 7.036l-2.482 2.482.708.707 2.482-2.482a5 5 0 0 0 7.036-7.036Zm-2.133.719a3 3 0 0 0-4.184 4.184l4.184-4.184Zm-3.476 4.89 4.183-4.183a3 3 0 0 1-4.184 4.184Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconToolsDiameterSizeS;
